import { getGlobals } from "storyblok/api"
import { getServiceArchive, getAllServiceArchivePaths, getServiceItemsByArchive } from "storyblok/services"
import HeaderImage from "components/DynamicComponent/atoms/HeaderImage"
import { Crumb } from "components/Breadcrumbs"
import CardSection from "components/DynamicComponent/molecules/CardSection"
import CTABanner from "components/DynamicComponent/atoms/CTABanner"
import Meta from "components/Meta"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function ServicesArchive({ story, services, fullSlug, meta }) {
  return (
    <>
      <Meta info={meta} />
      <main>
        <StoryblokVisualEditor story={story?.content}>
          <HeaderImage blok={story?.content} />
          <nav aria-label="Breadcrumb" className="px-6 py-6">
            <ol className="mx-auto w-full max-w-screen-xl">
              <Crumb {...{ text: "Home", href: "/" }} />
              <Crumb {...{ text: story?.content?.title, href: fullSlug, last: true }} />
            </ol>
          </nav>
          <section className="px-6">
            <h1 className="mx-auto w-full max-w-screen-xl font-medium text-teal-dark">{story?.content?.title}</h1>
          </section>
        </StoryblokVisualEditor>
        <CardSection
          blok={{
            columns: "three-columns",
            cards: services,
          }}
        />
      </main>
      <CTABanner />
    </>
  )
}

export async function getStaticProps({ params: { category }, preview = null }) {
  const globals = await getGlobals()
  const fullSlug = `services/${category}`
  const story = await getServiceArchive(fullSlug, preview)
  const services = await getServiceItemsByArchive(fullSlug)

  return {
    props: {
      fullSlug,
      meta: story?.content?.twentysixty_seo ?? null,
      preview,
      story: story ?? null,
      services: services ?? null,
      globals: globals ?? null,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllServiceArchivePaths(),
    fallback: false,
  }
}
